export const fmtCVE = (v) =>
  new Intl.NumberFormat("pt-PT", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
    Number(v || 0)
  ) + " CVE";

export const fmtCVE0 = (v) =>
  new Intl.NumberFormat("pt-PT", { maximumFractionDigits: 0, useGrouping: "always" }).format(Number(v || 0)) + " CVE";

export const fmtEUR = (v) =>
  new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR" }).format(Number(v || 0));

export const fmtNum = (v) =>
  new Intl.NumberFormat("pt-PT", { maximumFractionDigits: 2 }).format(Number(v || 0));

export const fmtDate = (v) => {
  if (!v) return "—";
  try {
    return new Date(v).toLocaleDateString("pt-PT", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return v;
  }
};

export const INVOICE_STATUS = {
  rascunho: { label: "Rascunho", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  emitida: { label: "Emitida", cls: "bg-blue-100 text-blue-800 border-blue-200" },
  enviada: { label: "Enviada", cls: "bg-blue-100 text-blue-800 border-blue-200" },
  paga: { label: "Paga", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  parcialmente_paga: { label: "Parcial", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  vencida: { label: "Vencida", cls: "bg-red-100 text-red-800 border-red-200" },
  anulada: { label: "Anulada", cls: "bg-red-50 text-red-700 border-red-200 line-through" },
};

export const QUOTE_STATUS = {
  rascunho: { label: "Rascunho", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  enviado: { label: "Enviado", cls: "bg-blue-100 text-blue-800 border-blue-200" },
  aprovado: { label: "Aprovado", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  rejeitado: { label: "Rejeitado", cls: "bg-red-100 text-red-800 border-red-200" },
  expirado: { label: "Expirado", cls: "bg-amber-100 text-amber-800 border-amber-200" },
};

export const DOC_TYPES = {
  proforma: "Pró-forma",
  recibo_interno: "Recibo interno",
};

export const NO_FISCAL_NOTE = "Documento sem valor fiscal";

export const SECTORS = {
  restauracao: "Restauração",
  construcao: "Construção",
  comercio: "Comércio",
  servicos: "Serviços",
};

export const PAYMENT_METHODS = {
  numerario: "Numerário",
  transferencia: "Transferência",
  vinti4: "Vinti4 / SISP",
  cheque: "Cheque",
  outro: "Outro",
};

export const ISLANDS = [
  "Santiago", "São Vicente", "Santo Antão", "Fogo", "Sal", "Boa Vista", "Maio", "Brava", "São Nicolau",
];
